import dayjs from "dayjs"

export type DateRangePresetId =
  | `today`
  | `yesterday`
  | `last-7-days`
  | `last-30-days`
  | `last-week`
  | `last-month`
  | `year-to-date`

export type DateRangePreset = {
  id: DateRangePresetId
  label: string
  start: Date
  end: Date
}

const presets = [
  {
    id: `today`,
    label: `Today`,
    start: dayjs().startOf(`day`).toDate(),
    end: dayjs().endOf(`day`).toDate()
  },
  {
    id: `yesterday`,
    label: `Yesterday`,
    start: dayjs().subtract(1, `day`).startOf(`day`).toDate(),
    end: dayjs().subtract(1, `day`).endOf(`day`).toDate()
  },
  {
    id: `last-7-days`,
    label: `Last 7 days`,
    start: dayjs().subtract(7, `day`).startOf(`day`).toDate(),
    end: dayjs().endOf(`day`).toDate()
  },
  {
    id: `last-30-days`,
    label: `Last 30 days`,
    start: dayjs().subtract(30, `day`).startOf(`day`).toDate(),
    end: dayjs().endOf(`day`).toDate()
  },
  {
    id: `last-week`,
    label: `Last week`,
    start: dayjs()
      .subtract(new Date().getDay() + 7, `day`)
      .startOf(`day`)
      .toDate(),
    end: dayjs().subtract(new Date().getDay(), `day`).endOf(`day`).toDate()
  },
  {
    id: `last-month`,
    label: `Last month`,
    start: dayjs()
      .subtract(new Date().getDate(), `day`)
      .startOf(`month`)
      .startOf(`day`)
      .toDate(),
    end: dayjs().subtract(new Date().getDate(), `day`).endOf(`day`).toDate()
  },
  {
    id: `year-to-date`,
    label: `Year to date`,
    start: dayjs().startOf(`year`).toDate(),
    end: dayjs().endOf(`day`).toDate()
  }
] as DateRangePreset[]

export default presets
